import React, { Component } from 'react';
import api from 'api';
import { debounce, get } from 'lodash';
import styled from 'styled-components';
import { TableApp } from 'components/IterioApp/components/TableApp';
import Loading from 'components/Loading/Loading';
import LoaderSmall from 'components/loaders/LoaderSmall';

import UserTableHeader from '../UserTableHeader';
import UserTableBody from '../UserTableBody';

const StyledUsersTable = styled.div`
  height: calc(100vh - 117px);
  overflow: auto;
  position: relative;
`;

const InfiniteLoader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 5px 0;
`;

class UsersTable extends Component {
  constructor(props) {
    super(props);
    this.state = { showProgressScroll: false };
    this.infiniteScroll = debounce(this.infiniteScroll.bind(this), 5);
    this.updateDataSuccess = this.updateDataSuccess.bind(this);
    this.updateDataFailure = this.updateDataFailure.bind(this);
  }

  componentDidMount() {
    this.initScrollEvent();
  }

  initScrollEvent() {
    this.scrollContent = document.querySelector('.js-UsersTable__scroll');
    if (this.scrollContent) this.scrollContent.addEventListener('scroll', this.infiniteScroll);
  }

  infiniteScroll() {
    const { next } = this.props;
    const { showProgressScroll } = this.state;
    if (!this.isScrollingDisabled(next, showProgressScroll)) this.updateData();
  }

  isScrollingDisabled(nextPage, showProgressScroll) {
    const scrollBottomPosition = this.scrollContent.scrollTop + this.scrollContent.clientHeight;
    const contentHeight = (this.scrollContent.scrollHeight);
    const loadPropertiesHeight = contentHeight * 0.7;

    return (scrollBottomPosition < loadPropertiesHeight) || showProgressScroll || !nextPage;
  }

  updateData() {
    const { next } = this.props;

    this.setState({ showProgressScroll: true }, () => {
      api.request({
        url: api.extractEndpointFromLink(next),
        cb: this.updateDataSuccess,
        cbError: this.updateDataFailure,
      });
    });
  }

  updateDataSuccess(response) {
    const { updateUsersData } = this.props;
    const users = get(response, 'data.users');
    const next = get(response, 'data.pages.next');

    this.setState({ showProgressScroll: false }, () => {
      updateUsersData(users, next);
    });
  }

  updateDataFailure() {
    this.setState({ showProgressScroll: false });
  }

  render() {
    const {
      users,
      selectedUsers,
      handleSelectUser,
      handleSelectUsers,
      usersPending,
      usersSuccess,
    } = this.props;

    const { showProgressScroll } = this.state;
    const showInfiniteLoader = showProgressScroll && usersSuccess;

    const usersTable = (
      <TableApp fixed>
        <UserTableHeader />

        <UserTableBody
          users={users}
          handleSelectUser={handleSelectUser}
          handleSelectUsers={handleSelectUsers}
          selectedUsers={selectedUsers}
        />
      </TableApp>
    );

    return (
      <StyledUsersTable className="js-UsersTable__scroll">
        {usersPending && <Loading fullAbsolute loadingLabel="Data on the way..." />}
        {usersSuccess && usersTable}

        {showInfiniteLoader && (
          <InfiniteLoader>
            <LoaderSmall />
          </InfiniteLoader>
        )}
      </StyledUsersTable>
    );
  }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/UsersTable/UsersTable.js